export const style = {
    padding: "10px",
    margin: "5px",
    borderRadius: "12px",
    backgroundColor: "#7ec3ff",
    fontFamily: "VerizonNHGDSBold",
};

export const videoWrapperDefault = {
    overflow: "hidden",
    width: "100%",
};

export const videoWrapperCustom = {
    position: "relative",
    overflow: "hidden",
    height: "38vh",
};

export const iframeStyle = {
    border: 0,
    alignSelf: "center",
    position: "absolute",
    top: "10px",
    left: "10px",
    width: "97%",
    height: "97%",
};
